<template>
  <div class="order-list">
    <CCard>
      <CCardHeader class="d-flex align-items-center justify-content-between">
        <strong>لیست سفارشات</strong>
        <span v-if="customer" class="text-muted small">
          مشتری: {{ customer.name || customer.mobile }}
          <CButton size="sm" color="link" @click="$router.push('/dashboard/orders/list')">همه سفارش‌ها</CButton>
        </span>
      </CCardHeader>
      <CCardBody>
        <ServerTable ref="table" url="/api/admin/order/get_all_orders" :fields="fields" :tabs="tabs" :params="params"
                     search-placeholder="کد سفارش، موبایل یا نام مشتری" empty-text="سفارشی یافت نشد" @loaded="onLoaded">
          <template #code="{item}"><td><strong>{{ item.code }}</strong></td></template>
          <template #created_at="{item}"><td class="text-muted">{{ get_date_time(item.created_at) }}</td></template>
          <template #customer="{item}"><td>{{ item.customer.name || '—' }}<div class="small text-muted">{{ item.customer.mobile }}</div></td></template>
          <template #payable="{item}"><td>{{ get_currency(item.payable) }} <small class="text-muted">تومان</small></td></template>
          <template #status="{item}"><td><span :class="['badge', badge(item.status)]">{{ item.status_title }}</span>
            <div class="small text-muted">{{ item.payment_status === 'paid' ? 'پرداخت شده' : 'پرداخت نشده' }}</div></td></template>
          <template #operation="{item}">
            <td><CButton color="primary" variant="outline" square size="sm" @click="$router.push('/dashboard/orders/info/' + item.id)">
              <CIcon name="cil-magnifying-glass" size="sm"/> جزئیات</CButton></td>
          </template>
        </ServerTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ServerTable from "@/views/includes/ServerTable.vue";

export default {
  name: 'OrderList',
  components: { ServerTable },
  data() {
    return {
      statuses: [],
      customer: null,
      fields: [
        { key: 'code', label: 'کد سفارش' },
        { key: 'created_at', label: 'تاریخ ثبت' },
        { key: 'customer', label: 'مشتری' },
        { key: 'items_count', label: 'تعداد اقلام' },
        { key: 'payable', label: 'مبلغ' },
        { key: 'status', label: 'وضعیت' },
        { key: 'operation', label: 'عملیات', _style: 'width:110px' },
      ],
    }
  },
  computed: {
    params() { return this.$route.params.customer_id ? { customer_id: this.$route.params.customer_id } : {} },
    tabs() { return [{ value: '', label: 'همه' }].concat(this.statuses.map((s) => ({ value: s.id, label: s.title }))) },
  },
  watch: {
    '$route.params.customer_id'() { this.customer = null },
  },
  methods: {
    onLoaded(d) {
      if (!this.statuses.length && d.statuses) this.statuses = d.statuses
      if (this.$route.params.customer_id && d.items && d.items[0]) this.customer = d.items[0].customer
    },
    badge(s) {
      return { pending: 'badge-warning', processing: 'badge-info', shipped: 'badge-primary', delivered: 'badge-success', cancelled: 'badge-danger', returned: 'badge-secondary' }[s] || 'badge-light'
    },
  },
}
</script>
